import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=49ccc88e&"
import script from "./StudentCard.vue?vue&type=script&lang=ts&"
export * from "./StudentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports